"use client";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en" dir="ltr">
      <body>
        <div style={{ padding: "40px", textAlign: "center" }}>
          <h2>Something went wrong!</h2>
          <button onClick={() => reset()} style={{ marginTop: "16px", padding: "8px 16px" }}>
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
